import { useEffect, useState } from 'react';

// La jornada en curso y la revelacion de su clasificacion (Jornada::OCULTA en el
// backend). Esta oculta por defecto y vuelve a ocultarse con cada vino que se
// cierra; el panel desvela el 3.o, el 2.o y el 1.o, y del 4.o para abajo sigue
// oculto hasta el final, para que el ganador no se adivine por descarte. Tapa a
// la vez la jornada y, si cuenta, la liga. Se pregunta cada pocos segundos para
// verlo en directo.
const CADA_MS = 3000;

// { revelacion, en_curso }: la jornada que se esta jugando (o null) y, mientras
// no se ha desvelado entera, la misma con lo que se ve (o null). Hasta la
// primera respuesta, null. Solo cambia si cambia algo (tambien al cerrarse un
// vino, por vinos_cerrados), asi que sirve para volver a pedir los puntos.
export const useJornadaEnCurso = () => {
    const [estado, setEstado] = useState(null);

    useEffect(() => {
        let vivo = true;
        const consultar = () =>
            fetch(`${process.env.REACT_APP_API_URL}/revelacion`)
                .then((respuesta) => (respuesta.ok ? respuesta.json() : { revelacion: null, en_curso: null }))
                .then(({ revelacion = null, en_curso = null }) => {
                    if (!vivo) return;
                    const nuevo = { revelacion, en_curso };
                    // Solo cambia el estado si cambia algo: asi no se repinta cada 3 s
                    setEstado((antes) => (JSON.stringify(antes) === JSON.stringify(nuevo) ? antes : nuevo));
                })
                .catch(() => {});
        consultar();
        const intervalo = setInterval(consultar, CADA_MS);
        return () => {
            vivo = false;
            clearInterval(intervalo);
        };
    }, []);

    return estado;
};

// La revelacion que tapa una vista: la de la jornada que se desvela y, si esa
// jornada cuenta, tambien la de la liga
export const revelacionDe = (estado, vista) => {
    const revelacion = estado && estado.revelacion;
    if (!revelacion) return null;
    if (vista === 'liga') return revelacion.puntua ? revelacion : null;
    return vista === String(revelacion.id) ? revelacion : null;
};

// Lo unico que se desvela puesto a puesto
const PODIO = 3;

// Si un puesto (1, 2, 3...) sigue sin desvelarse: los de fuera del podio, hasta
// que se ve entera (y entonces ya no hay revelacion)
export const oculto = (revelacion, puesto) =>
    Boolean(revelacion) && (puesto > PODIO || puesto < revelacion.visible_desde);

// Clase de lo que se desvela: desenfocado mientras esta oculto, y enfoca al desvelarse
export const claseRevelable = (revelacion, puesto) => 'revelable' + (oculto(revelacion, puesto) ? ' oculta' : '');
